export function abbreviateNumber(number) {

    if(number<1_000) return `${number}`;

    if(number<10_000) return `${Math.round(number/1000*100)/100}k`;

    if(number<100_000) return `${Math.round(number/1000*10)/10}k`;

    if(number<1_000_000) return `${Math.round(number/1000)}k`;

    if(number<1_0_000_000) return `${Math.round(number/1_000_000*100)/100}M`;
    if(number<1_00_000_000) return `${Math.round(number/1_000_000*10)/10}M`;
    if(number<1_000_000_000) return `${Math.round(number/1_000_000)}M`;
}